import React from "react";
import { useState } from "react";
import "./qualification.css";
import { AnimateSharedLayout, motion } from "framer-motion";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <section className="qualification section" id="experience">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Personal Journey</span>
      <div className="qualification__container container">
        <div className="qualification__tabs">
          <AnimateSharedLayout>
            <div
              className={
                toggleState === 1
                  ? "qualification__button qualification__active buton--flex"
                  : "qualification__button buton--flex"
              }
              onClick={() => toggleTab(1)}
            >
              <i className="uil uil-graduation-cap qualification__icon"></i>
              Education
              {toggleState === 1 && (
                <motion.div
                  layoutId="underline"
                  className="underline"
                ></motion.div>
              )}
            </div>{" "}
            <div
              className={
                toggleState === 2
                  ? "qualification__button qualification__active buton--flex"
                  : "qualification__button buton--flex"
              }
              onClick={() => toggleTab(2)}
            >
              <i className="uil uil-briefcase-alt qualification__icon"></i>
              Experience
              {toggleState === 2 && (
                <motion.div
                  layoutId="underline"
                  className="underline"
                ></motion.div>
              )}
            </div>
          </AnimateSharedLayout>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  B.E. (Computer Engineering)
                </h3>
                <span className="qualification__subtitle">
                  NBN Sinhagad School of Engineering, Pune
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2019-2023
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">12th</h3>
                <span className="qualification__subtitle">
                  Gaurav High School & Junior College, Nerul
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2018-2019
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">10th</h3>
                <span className="qualification__subtitle">
                  HOCL School, Rasayani
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2016-2017
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>
          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Software Development Internship
                </h3>
                <span className="qualification__subtitle">
                  Curiosity Edtech Private Limited
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 11/2021 - 4/2022
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  Web Development Internship
                </h3>
                <span className="qualification__subtitle">
                  The Spark Foundation
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 09/2021 - 10/2021
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
